import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClientTesting } from '@angular/common/http/testing';
import { provideLocationMocks } from '@angular/common/testing';
import { ActivatedRoute, provideRouter } from '@angular/router';

import { TmsLibModule } from './tms-shared';
import { AuthService, MockAuthService } from './auth';

@NgModule({
  imports: [TmsLibModule],
  providers: [
    provideZoneChangeDetection(),
    provideRouter([]),
    provideLocationMocks(),
    provideHttpClientTesting(),
    { provide: AuthService, useClass: MockAuthService },
    // ⚠️ The stub snapshot must carry `data` and `queryParams`, not just `paramMap`. A REAL
    // ActivatedRoute snapshot always has all three, so a component that reads
    // `route.snapshot.data['stage']` is correct - but against a stub without them it throws
    // "Cannot read properties of undefined", and the spec fails for a reason that has nothing
    // to do with the component. Empty objects are the honest stub: the property resolves to
    // undefined, which is what a route with no data would give.
    // (Scanner PieceProgressComponent, 2026-07-31; app-search-grid reads queryParams.back the
    // same way and would have hit it next.)
    //
    // ⚠️ `queryParamMap` is a FOURTH member, and it is a map like paramMap rather than
    // a plain object - a real snapshot carries both it and `queryParams`. It returns null
    // here because that is what a route with no query string gives, so a component
    // reading `queryParamMap.get('customerId') ?? ''` takes its own default.
    // (TmsAdmin SpecEditComponent, 2026-09-21.)
    {
      provide: ActivatedRoute,
      useValue: {
        snapshot: {
          paramMap: { get: () => '123' },
          queryParamMap: { get: () => null },
          data: {},
          queryParams: {},
        },
      },
    },
  ],
})
export class BaseTestingModule {}
